<template>
  <form @submit.prevent="submit">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">DUPLICATE WORK ORDER</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Duplicate">
          <b-input type="text" v-model="data.duplicateOf"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button class="button is-primary" :disabled="loading">Save</button>
      </footer>
    </div>
  </form>
</template>
<script>
import { OrderService } from "@/services/order.service";

export default {
  data: () => ({
    orderService: OrderService,
    data: {
      duplicateOf: null
    },
    loading: false
  }),
  props: {
    order: {
      type: Object,
      required: true
    },
  },
  watch:{
    order:{
      handler: function(order) {
        this.data.duplicateOf = order.duplicateOf
      },
      deep: true,
    }
  },

  methods: {
    async submit() {
      this.loading = true;
      this.orderService.closeDuplicate(this.order.id, this.data)
      .then(() => {
        this.$store.dispatch("OrderState/fetchState", this.order.id);
        this.$parent.close();
        this.$buefy.toast.open({
          message: "Duplicate work order saved.",
          type: "is-success",
          position: "is-top-right"
        });
      })
      .catch(() => {
          // AJAX interceptor should have handled this.
      })
      .finally(() => {
          this.loading = false;
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Orders/list-new/partials/OrderDuplicateModal.vue